import { types } from 'mobx-state-tree';

export const AppealManagementModel = types
  .model('AppealManagement', {
    selectedDepartmentID: types.optional(types.maybeNull(types.string), null),
    isSearchActive: types.optional(types.boolean, false),
  })
  .actions((self) => ({
    updateField<K extends keyof typeof self>(
      fieldName: K,
      value: typeof self[K]
    ) {
      self[fieldName] = value;
    },
  }));
